import { schema } from 'normalizr';

export const user = new schema.Entity('users');

export const page = new schema.Entity('pages', {
	author: user,
});

export const pageFile = new schema.Entity('pageFiles');

export const product = new schema.Entity('products');

export const group = new schema.Entity('groups');

export const timezone = new schema.Entity(
	'timezones',
	{},
	{
		idAttribute: 'value',
	}
);

export const adminNotification = new schema.Entity('adminNotifications', {
	author: user,
});

export const PICategory = new schema.Entity(
	'PICategories',
	{},
	{
		idAttribute: 'id',
	}
);

export const PISheet = new schema.Entity('PISheets', {
	category: PICategory,
});

export const bulletinTag = new schema.Entity('bulletinTags');

export const bulletin = new schema.Entity('bulletins');

export const cr = new schema.Entity('CRs');

export const crSummaries = new schema.Entity('CRSummaries');

export const qsrType = new schema.Entity('QSRTypes');

export const qsrCategory = new schema.Entity('QSRCategories');

export const qsrItem = new schema.Entity('QSRItems', {
	type: qsrType,
});

export const qsr = new schema.Entity('QSRs', {
	items: [qsrItem],
});

export const qsrSummaries = new schema.Entity('QSRSummaries');

export const manufacturer = new schema.Entity('QSRManufacturers');

export const qsrProductType = new schema.Entity('QSRProductTypes');

export const oem = new schema.Entity('oems');

export const endUser = new schema.Entity('endUsers');

export const endUserSerialNumber = new schema.Entity('endUserSerialNumbers');

export const adminOem = new schema.Entity('adminOems');

export const folder = new schema.Entity('folders');

export const sourcesafeEntry = new schema.Entity('sourcesafeEntries');



// WEBPACK FOOTER //
// ./src/schema.js